import type { HasStockBalance} from "@towni/common";
import { hasProperty, type Sku } from "@towni/common";

const hasStockBalance = (sku: Sku | undefined): sku is HasStockBalance => {
    if (!sku) return false;
    return hasProperty(sku, "trackStockBalance");
};

export { hasStockBalance };
